import { render, staticRenderFns } from "./DadosCID.vue?vue&type=template&id=e20bbe44&"
import script from "./DadosCID.vue?vue&type=script&lang=js&"
export * from "./DadosCID.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports